var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_1102)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M400 504.673C428.791 504.673 452.134 481.33 452.134 452.539V214.84C452.134 186.045 428.791 162.705 400 162.705C371.209 162.705 347.866 186.045 347.866 214.84V452.543C347.866 481.334 371.209 504.673 400 504.673Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.013 533.051C386.291 533.051 372.815 538.598 363.139 548.316C353.425 557.992 347.878 571.422 347.878 585.144C347.878 598.866 353.425 612.337 363.139 622.013C372.815 631.731 386.291 637.278 400.013 637.278C413.734 637.278 427.164 631.731 436.882 622.013C446.554 612.337 452.147 598.866 452.147 585.144C452.147 571.422 446.554 557.992 436.882 548.316C427.164 538.598 413.734 533.051 400.013 533.051Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400 0C179.442 0 0 179.438 0 400C0 620.562 179.438 800 400 800C620.562 800 799.996 620.562 799.996 400C799.996 179.438 620.562 0 400 0ZM400 737.439C213.934 737.439 62.5613 586.066 62.5613 400C62.5613 213.934 213.934 62.5613 400 62.5613C586.061 62.5613 737.435 213.934 737.435 400C737.435 586.066 586.066 737.439 400 737.439Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_1102"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 800,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcExclamation);
export default __webpack_public_path__ + "static/media/ic-exclamation.3740d5553d8855bf9a61e2e5073d766d.svg";
export { ForwardRef as ReactComponent };